import validate from '../validate';
import NativeFormAPI from './nativeFormAPI';
import inputStates from '../iframes/inputStates';
import toggleContactCheckbox from '../iframes/toggleContactCheckbox';

export default class HalfsiesForm {
  /*
    formSelector - pass in the formSelector
    customFormId - pass in the id of the custom form on this page
    host - pass in the host of where this reqquest will go
      - example: locally: localhost:3000 or
      - staging: stagin.emerituss.org
      - production: admissions.emeritus.org
    submitButtonSelector - the selector of the submit button for loading states and disabling
      - default: 'input[type=submit]'
    disabledBtnClass - the class that gets added when a form is submitting
      - default 'btn--disabled'
    submitBtnText - the text of the submit button. For when a form doesn't save correctly.
      We still have to return the button to it's original text
      - default: 'Download Brochure'
    loadingStateText - the text of the submit button when the form is submitting
      - default: 'Loading'
    validations - javascript object of keys to be validated and the HTML5 errors that we handle
      - there is no default and you actually don't need to provide any if you are alright
      with the browser handling the text that is displayed
    const form = document.querySelector('form');
    const customFormId = 7;
    const host = 'admissions.emeritus.org';
    halfsiesValidations = HalfsiesFormValidations.new({
      form,
      customFormId,
      host,
      submitButtonSelector: '.submit-button',
    })
  */

  constructor (options = {}) {
    /*
      Required Params
    */
    if (typeof options.customFormId === 'undefined') {
      throw new Error('must enter a customFormId options.customFormId');
    }

    if (typeof options.form === 'undefined') {
      throw new Error('must enter a form element or selector for options.form');
    }

    if (typeof options.host === 'undefined') {
      throw new Error('must enter a host for options.form');
    }

    this.customFormId = options.customFormId;
    this.customFormRedirectPath = options.customFormRedirectPath;
    this.cpEnabled = options.coursePreviewLandingPageEnabled || false;
    this.host = options.host;
    this.formSelector = options.formSelector || 'form';
    this.form = options.form || document.querySelector(this.formSelector);
    this.paramString = options.paramString || '';
    this.submitButtonSelector = options.submitButtonSelector || 'input[type=submit]';
    this.submitButton = this.form.querySelector(this.submitButtonSelector);
    this.disabledBtnClass = options.submitButtonSelector || 'btn--disabled';
    this.submitBtnText = options.submitBtnText || 'Download Brochure';
    this.loadingStateText = options.loadingStateText || 'Loading';
    this.afterSubmit = options.afterSubmit || function afterSubmit () { };
    this.init();
  }

  init () {
    validate(this.formSelector, this.validateOptions());
    this.nativeFormAPI = new NativeFormAPI({
      afterSubmit: this.afterSubmit,
      coursePreviewLandingPageEnabled: this.cpEnabled,
      customFormId: this.customFormId,
      customFormRedirectPath: this.customFormRedirectPath,
      form: this.form,
      formSelector: this.formSelector,
      host: this.host,
      submitButtonSelector: this.submitButtonSelector,
    });

    inputStates();
    toggleContactCheckbox();
    this.setCoursePreviewValue();
  }

  /*
    Now that the same custom form can be for the Course Preview version
    of the page and the Legacy version we need to be able to send this information
    to the server so that analytics can tell the difference.
  */
  setCoursePreviewValue () {
    const input = document.querySelector('#custom_form_entry_course_preview');
    input.value = this.coursePreviewLandingPageEnabled;
  }


  /*
    returns the javascript object needed for our validations library
  */
  validateOptions () {
    return {
      inputName: this.inputName,
      errorMessage: this.errorMessage,
      findParentNode: this.findParentNode,
      validations: this.validations,
    };
  }

  /*
    We have to define our own custom findParentNode method because this form is
    different than what the original form was like. So the library gives us the option
    to define how we find the parent node to insert the error div into
  */
  findParentNode = (input) => {
    const { parentNode } = input;

    return parentNode;
  }

  /*
    We have to define our own input here to make sure that we can find the input
    when we get an error back from the server. So this is really only for server side
    validations.
    In most cases we would just find it by the name of the field but in the halfsies case
    the field is custom_form_entry[1] or similar. Since the number changes between environments
    we need to find it by concatenating the custom_form_entry_ string and the name
  */
  findInput = (name) => {
    if (name === 'phone') {
      return document.getElementById('custom_form_entry_mobile_no');
    }

    return document.getElementById(`custom_form_entry_${name}`);
  }

  inputName = input => input.id.split('custom_form_entry_')[1]


  errorMessage (model, name, attr) {
    let validationMessage;
    try {
      validationMessage = this.validation[name][attr];
    } catch {
      return validationMessage;
    }

    return validationMessage;
  }

  fetch () {
    return this.nativeFormAPI.fetch();
  }
}
